import React, { useState } from "react";
import BCModal from "../../ui/BCModal";
import LmsActionInput from "../ui/LmsActionInput";
import LmsFormGenerator, { BCFormController } from "../ui/LmsFormGenerator";
import LmsTable from "../ui/LmsTable";
import { GlobalConstants } from "../../constants/GlobalConstants";

const processDrawFormFields = (myForm) => {
  myForm.addGroupFields([
    myForm.getLabelField("", { width: "3", position: "center" }),
    myForm.getLabelField("Wire", { width: "3", position: "center" }),
    myForm.getLabelField("Check", { width: "3", position: "center" }),
    myForm.getLabelField("ACH", { width: "3", position: "center" }),
    myForm.getLabelField("Total", { width: "3", position: "center" }),
  ], { widths: "2" });

  myForm.addGroupFields([
    myForm.getLabelField("Wire Date", { width: "3", position: "center" }),
    myForm.getCalendarField("", { width: "3", position: "center" }),
    myForm.getCalendarField("", { width: "3", position: "center" }),
    myForm.getCalendarField("", { width: "3", position: "center" }),
    myForm.getLabelField("", { width: "3", position: "center" }),
  ], { widths: "2" });

  myForm.addGroupFields([
    myForm.getLabelField("Total # of Draws Funded", { width: "3", position: "center" }),
    myForm.getInputField("", { width: "3", position: "center" }),
    myForm.getInputField("", { width: "3", position: "center" }),
    myForm.getInputField("", { width: "3", position: "center" }),
    myForm.getInputField("", { width: "3", position: "center" }),
  ], { widths: "2" });

  myForm.addGroupFields([
    myForm.getLabelField("Total Funded Amount", { width: "3", position: "center" }),
    myForm.getInputField("", { width: "3", position: "center" }),
    myForm.getInputField("", { width: "3", position: "center" }),
    myForm.getInputField("", { width: "3", position: "center" }),
    myForm.getInputField("", { width: "3", position: "center" }),
  ], { widths: "2" });

  myForm.addGroupFields([
    myForm.getLabelField("BCS-1", { width: "3", position: "center" }),
    myForm.getInputField("", { width: "3", position: "center" }),
    myForm.getInputField("", { width: "3", position: "center" }),
    myForm.getInputField("", { width: "3", position: "center" }),
    myForm.getInputField("", { width: "3", position: "center" }),
  ], { widths: "2" });

  myForm.addGroupFields([
    myForm.getLabelField("LP Funded", { width: "3", position: "center" }),
    myForm.getInputField("", { width: "3", position: "center" }),
    myForm.getInputField("", { width: "3", position: "center" }),
    myForm.getInputField("", { width: "3", position: "center" }),
    myForm.getInputField("", { width: "3", position: "center" }),
  ], { widths: "2" });

  myForm.addGroupFields([
    myForm.getLabelField("Cash", { width: "3", position: "center" }),
    myForm.getInputField("", { width: "3", position: "center" }),
    myForm.getInputField("", { width: "3", position: "center" }),
    myForm.getInputField("", { width: "3", position: "center" }),
    myForm.getInputField("", { width: "3", position: "center" }),
  ], { widths: "2" });

  myForm.addGroupFields([
    myForm.getLabelField("Pending Cash", { width: "3", position: "center" }),
    myForm.getInputField("", { width: "3", position: "center" }),
    myForm.getInputField("", { width: "3", position: "center" }),
    myForm.getInputField("", { width: "3", position: "center" }),
    myForm.getInputField("", { width: "3", position: "center" }),
  ], { widths: "2" });

  myForm.addGroupFields([
    myForm.getLabelField("Budget Draw Total", { width: "3", position: "center" }),
    myForm.getInputField("", { width: "3", position: "center" }),
    myForm.getInputField("", { width: "3", position: "center" }),
    myForm.getInputField("", { width: "3", position: "center" }),
    myForm.getInputField("", { width: "3", position: "center" }),
  ], { widths: "2" });

  myForm.addGroupFields([
    myForm.getLabelField("Wire Fee Total", { width: "3", position: "center" }),
    myForm.getInputField("", { width: "3", position: "center" }),
    myForm.getInputField("", { width: "3", position: "center" }),
    myForm.getInputField("", { width: "3", position: "center" }),
    myForm.getInputField("", { width: "3", position: "center" }),
  ], { widths: "2" });

  myForm.addGroupFields([
    myForm.getLabelField("Datedown Endorsement Fee Total", { width: "3", position: "center" }),
    myForm.getInputField("", { width: "3", position: "center" }),
    myForm.getInputField("", { width: "3", position: "center" }),
    myForm.getInputField("", { width: "3", position: "center" }),
    myForm.getInputField("", { width: "3", position: "center" }),
  ], { widths: "2" });

  myForm.addGroupFields([
    myForm.getLabelField("Inspection Site Visit Total", { width: "3", position: "center" }),
    myForm.getInputField("", { width: "3", position: "center" }),
    myForm.getInputField("", { width: "3", position: "center" }),
    myForm.getInputField("", { width: "3", position: "center" }),
    myForm.getInputField("", { width: "3", position: "center" }),
  ], { widths: "2" });

  myForm.addGroupFields([
    myForm.getLabelField("Draw Processing Fee Total", { width: "3", position: "center" }),
    myForm.getInputField("", { width: "3", position: "center" }),
    myForm.getInputField("", { width: "3", position: "center" }),
    myForm.getInputField("", { width: "3", position: "center" }),
    myForm.getInputField("", { width: "3", position: "center" }),
  ], { widths: "2" });

  myForm.addGroupFields([
    myForm.getLabelField("LP Payment Date", { width: "3", position: "center" }),
    myForm.getCalendarField("", { width: "3", position: "center" })
  ]);

  myForm.addGroupFields([
    myForm.getLabelField("JE", { width: "3", position: "center" }),
    myForm.getInputField("", { width: "3", position: "center" })
  ]);

  return myForm;
};

const ProcessDrawForm = () => {
  const myForm = processDrawFormFields(new BCFormController({}, { submitSuffix: "", blankWidth: 4 })); // TODO: Add submit suffix
  const formActions = [
    { text: "Process ACH", path: "" }, // TODO: endpoint
    { text: "Submit", action: "submit"},
    "close"
  ];

  return <LmsFormGenerator myForm={myForm} actions={formActions} />;
};

const DrawsInProcessWireTable = ({ drawId }) => {
  return <LmsTable apiSuffix={`draws/${drawId}/unfunded-wire-draws`} actionButtons={["export"]} />; // TODO: Add correct endpoint
};

const LmsAccountingDrawsInProcess = () => {
  const [isProcessDrawOpen, setIsCProcessDrawOpen] = useState(false);
  const [declineReason, setDeclineReason] = useState("");
  const actionButtons = [
    "export",
    "save", // TODO: inline table editing
    "cancel",
    {
      action: GlobalConstants.TableDefaultActions.DOWNLOAD_SELECTED,
      text: "BOA",
      downloadSuffix: "draws/boa",
      method: "POST",
      payloadContentType: "JSON",
      downloadMany: true,
      isDisabled: () => false
    },
    {
      action: GlobalConstants.TableDefaultActions.DOWNLOAD_SELECTED,
      text: "Sample ACH",
      downloadSuffix: "draws/sample-ach",
      method: "POST",
      payloadContentType: "JSON",
      downloadMany: true,
      isDisabled: () => false
    },
    {
      action: GlobalConstants.TableDefaultActions.DOWNLOAD_SELECTED,
      text: "ACH Analysis",
      downloadSuffix: "draws/ach-analysis",
      method: "POST",
      payloadContentType: "JSON",
      downloadMany: true,
      isDisabled: () => false
    },
    {
      action: GlobalConstants.TableDefaultActions.SUBMIT_SELECTED,
      text: "Process",
      icon: GlobalConstants.Icons.CARET_UP,
      submitSuffix: "draws/process-draws",
    },
    {
      action: GlobalConstants.TableDefaultActions.SUBMIT_SELECTED,
      text: "Move to Unfunded Draws",
      submitSuffix: "draws/unprocess-draws",
      icon: GlobalConstants.Icons.CARET_UP,
      refreshDataOnSuccess: true
    },
    {
      action: GlobalConstants.TableDefaultActions.SUBMIT_SELECTED,
      text: "Void Draw",
      submitSuffix: "draws/decline-draws",
      method: "PUT",
      alertMessage: !declineReason ? "Please enter decline reason?" : undefined,
      confirmationMessage: "Are you sure you want to void the selected record(s)?",
      handleFormatSubmitSelectedRows: (data) => {
        return { loanDrawIds: data.map(d => d.id), declineReason };
      },
      icon: GlobalConstants.Icons.CARET_UP
    },
    <LmsActionInput value={declineReason} handleChange={setDeclineReason} placeHolder="Decline Reason"/> as any
  ];

  const mainTableInlineEditingFormFields = (myForm) => {
    myForm.addCenteredGroup([
      myForm.getCheckboxField("Wire Created", { inlineEdit: true }),
      myForm.getCurrencyField("Date Down Fee", { inlineEdit: true }),
      myForm.getCurrencyField("Wire Fee", { inlineEdit: true }),
      myForm.getCurrencyField("Inspection Fee", { inlineEdit: true }),
      myForm.getCurrencyField("Inspection Site Visit Fee", { inlineEdit: true })
    ]);

    return myForm;
  };

  const formatDrawsInProcessInputs = (inputs, options) => {
    return options.recordsToUpdate.map((input) => {
      const { id, ...updatedColumns } = input;
      return {
        id,
        ...options.filteredData?.find((row) => row.id === id) || {},
        ...updatedColumns
      };
    });
  };

  return <>
    <BCModal
      isModalOpen={isProcessDrawOpen}
      size="large"
      closeIcon
      onClose={() => setIsCProcessDrawOpen(false)}
      content={<>
        <ProcessDrawForm />
      </>}
    />
    <LmsTable
      actionButtons={actionButtons}
      columnLabelsDictionary={{
        loanNumber: "Loan #",
        bcp: "BCP",
        lpwireAmt: "LP Wire Amt",
        ldrBinameOnBankAccount: "L Dr BI Name On Bank Account",
        ldrBibankAccountNumber: "L Dr BI Bank Account Number",
        wireCheck: "Payment Type",
        wireCheckCreated: "Payment Created"
      }}
      calculatedColumns={[
        "budgetDrawAmount", 
        "dateDownFee", 
        "inspectionFee", 
        "inspectionSiteVisitFee", 
        "wireFee", 
        "totalDrawAmt",
        "fundWireAmt",
        "lpwireAmt"
      ]}
      apiSuffix="draws/unfunded-loan-draws"
      onClickModalContent={(_, { clickedRowData }) => <DrawsInProcessWireTable drawId={clickedRowData?.id} />}
      onClickModalSize="fullscreen"
      columnClickOptions={{
        loanNumber: {
          idProp: "id",
          isModalContentLink: true,
        }
      }}
      myForm={mainTableInlineEditingFormFields(new BCFormController())}
      saveSuffix="draws/unfunded-draws"
      saveMethod="PUT"
      saveFormattingFunction={formatDrawsInProcessInputs}
    />
  </>;
};

export default LmsAccountingDrawsInProcess;